const publicUrl = (window as any).PUBLIC_URL || '/';

export default publicUrl;
export { publicUrl };
